import LegalActionsChecker from './LegalActionsChecker';

export default LegalActionsChecker;
